<template>
  <div>

    <!-- using v-show for !OFFLINE so that app state is preserved -->
    <router-view v-if="loaded" v-show="!OFFLINE">
    </router-view>
    <div v-if="OFFLINE">
      <div class="col-12 mt-5" style="padding-top: 10em">
        <offline-svg style="width: 100%; height:auto;"></offline-svg>
        <div class="row">
          <div class="col-12 text-center mt-5">
            <h6>{{ $t("message.Connection to server lost") }}</h6>
            <span>{{ $t("message.Please check your network") }}</span>
          </div>
        </div>
      </div>
    </div>
    <notifications></notifications>
  </div>
</template>

<script>
/* eslint-disable no-undef */
/* eslint-disable no-console */
import "sweetalert2/dist/sweetalert2.css";
import offline from "./services/offline";

import OfflineSvg from "./pages/carenation/components/svg_images/OfflineSvg.vue";
import UpgradeSvg from "./pages/carenation/components/svg_images/UpgradeSvg.vue";

export default {
  name: "app",

  components: {
    OfflineSvg,
    UpgradeSvg,
  },

  async mounted() {
    if (localStorage.user) {
      this.$store.commit("setState", {
        stateName: "currentUser",
        stateValue: JSON.parse(localStorage.user),
      });
    }

    //Run this only on apps
    if (window.cordova) {
      //It will be called when app is openned by clicking on the notification
      cordova.plugins.notification.local.on(
        "click",
        (data) => {
          //get details of the clicked notification by id
          cordova.plugins.notification.local.get(data.id, (res) => {
            //check if it is a water tracker notification
            let waterTrackerNotificationsIds = [];
            let waterTrackerNotification = false;
            if (localStorage.waterTrackerNotificationsIds) {
              waterTrackerNotificationsIds = JSON.parse(
                localStorage.waterTrackerNotificationsIds
              );
              waterTrackerNotification = waterTrackerNotificationsIds.includes(
                data.id
              );
            }
            //route based on the notification type
            if (res && res.hasOwnProperty("id") && res.data) {
              if (
                res.data.normalize().replace(/"/g, "") ==
                "medication notification"
              ) {
                this.$router.push("/reminders");
              } else if (
                res.data.normalize().replace(/"/g, "") == "fitness notification"
              ) {
                this.$router.push("/fitnesssets");
              } else if (
                res.data.normalize().replace(/"/g, "") == "yoga notification"
              ) {
                this.$router.push("/yogasets");
              }
            } else if (waterTrackerNotification) {
              this.$store.commit("setState", {
                stateName: "nutritionHomePageActiveTab",
                stateValue: "watertracker",
              });
              this.$router.push("/nutritionhome");
            } else {
              this.$router.push("/reminders");
            }
          });
        },
        this
      );
    }

    try {
      this.loaded = true;
      let settings;
      if (this.user) {
        offline.activate();
        settings = await this.$store.dispatch("getSettings");
      } else {
        settings = await this.$store.dispatch("getPublicSettings");
      }
    } catch (e) {
      console.log(e);
    }
  },

  data() {
    return {
      loaded: false,
      appLink: null,
    };
  },

  computed: {
    user() {
      if (localStorage.user) {
        return JSON.parse(localStorage.user);
      }
    },
  },

  methods: {
  },
};
</script>
<style>
@import "./assets/fonts/fontawesome/css/all.min.css";
</style>
